module.exports = __webpack_public_path__ + "static/media/initiateTestNow.3b4cecc8.svg";